import { ref, onUnmounted } from 'vue';
import posthog from 'posthog-js';

// Reactive wrapper around posthog-js feature flags. Flags load asynchronously
// after posthog.init(), so this starts at `false` and updates once PostHog
// has fetched the user's flag values (and again on any later change, e.g. an
// admin flipping the rollout percentage while the tab is open).
export function useFeatureFlag(key: string) {
  const isEnabled = ref(posthog.isFeatureEnabled(key) ?? false);

  const unsubscribe = posthog.onFeatureFlags(() => {
    isEnabled.value = posthog.isFeatureEnabled(key) ?? false;
  });

  onUnmounted(() => {
    unsubscribe?.();
  });

  return isEnabled;
}
